export const SELECT_VIEW = {
  DATE: 'date',
  MONTH: 'month',
  YEAR: 'year',
};
